import Vue from 'vue'
import App from './App.vue'
import router from './index'
import 'babel-polyfill'
import store from '../../store'
import common from '../../assets/js/config.js'
// import sf from '../../assets/js/suofang.js'

Vue.prototype.common = common;

if (document.body.getBoundingClientRect().width - 1 < 992) {
  window.location.href = 'https://tour.i-lianjiang.cn/ljxcx/index.html#/ljindex'
}
//引入swiper
// import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)

//引入全局组件
import head from '../../components/common/header'
import foot from '../../components/common/footerBak'
import list_breadcrumb from '../../components/index/list_breadcrumb'
import wzlj_img_swiper from '../../components/index/wzlj_img_swiper'
Vue.component('v-head',head);
Vue.component('v-footer',foot);
Vue.component('v-breadcrumb',list_breadcrumb);
Vue.component('v-img-swiper',wzlj_img_swiper);

Vue.config.productionTip = false;
import '../../assets/css/common.less';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);


//引入UE


new Vue({
  router,
  store,

  render: h => h(App)
}).$mount('#app')
